/**
 * Reusable yellow note/warning banner for edit tabs (Communications, Payments).
 * Matches Angular alert-ylw styling.
 */
interface NoteBannerProps {
    children: React.ReactNode;
    className?: string;
    "data-testid"?: string;
}

export function NoteBanner({ children, className = "", "data-testid": dataTestId }: NoteBannerProps) {
    return (
        <div
            className={`rounded-md px-3 sm:px-4 py-2.5 sm:py-3 text-xs sm:text-sm ${className}`}
            style={{ backgroundColor: "#fef9e7", border: "1px solid #f1c40f", color: "#8a6d3b" }}
            role="alert"
            data-testid={dataTestId}
        >
            {children}
        </div>
    );
}
